// extracted by mini-css-extract-plugin
export default {"add-tasks":"AddTasks_add-tasks__18fuc","header":"AddTasks_header__VqmAt","box":"AddTasks_box__nAM3F","submit":"AddTasks_submit__mxgo-"};